import { Component } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MenuNavComponent } from '../../../blocks/menu-nav/menu-nav.component';
import { MainPageAbstract } from '../../common/main-page.abstract';

@Component({
  selector: 'app-default-main-page',
  templateUrl: './default-main-page.component.html',
  styleUrls: ['./default-main-page.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    AsyncPipe,
    RouterOutlet,
    MatProgressSpinnerModule,
    MenuNavComponent,
  ]
})
export class DefaultMainPageComponent extends MainPageAbstract { }
